import Modal, { type ModalProps } from './Modal';
import NewModal, { type ModalProps as NewModalProps } from './NewModal';

export { Modal, NewModal, type ModalProps, type NewModalProps };
export default Modal;
